import React from 'react';
import {SimpleSwitch} from '../../Features/Fields/SimpleSwitch';
import FormRender, {FRProps} from 'form-render';
import {SearchProps} from 'form-render/lib/type';
import SelectDict from '../../Features/Select/SelectDict';
import {Spin} from 'antd';

type Prop = SearchProps<any> & FRProps;

interface Props extends Prop {}

const widgetList = {
    SimpleSwitch,
    SelectDict,
};

const Index = ({loading = false, ...props}: Props) => {
    return (
        <Spin spinning={loading}>
            <FormRender {...props} widgets={widgetList} />
        </Spin>
    );
};

export default Index;
